import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import type { AgendaItem } from "@repo/types";
import { AGENDA_ITEM_MOTIF } from "@/lib/constants";
import { AgendaItemReviewForm } from "./AgendaItemReviewForm";
import { useUserStore } from "@/stores/userStore";

export const AgendaItemReviewDialog = ({
  open: outerOpen,
  setOpen: outerSetOpen,
  tenantId,
  agendaItem,
}: {
  open?: boolean;
  setOpen?: (open: boolean) => void;
  disabled?: boolean;
  tenantId: string;
  agendaItem: AgendaItem;
}) => {
  const { activeTeam, user } = useUserStore((s) => ({
    activeTeam: s.activeTeam,
    user: s.user,
  }));

  const [innerOpen, innerSetOpen] = useState(false);

  const open = outerOpen ?? innerOpen;
  const setOpen = outerSetOpen ?? innerSetOpen;

  const handleOpenChange = () => setOpen(!open);

  if (!activeTeam || !user) return <div>Loading...</div>;

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader className={AGENDA_ITEM_MOTIF}>
          <DialogTitle>Record Decision for {agendaItem.name}</DialogTitle>
        </DialogHeader>
        <AgendaItemReviewForm
          tenantId={tenantId}
          agendaItem={agendaItem}
          handleCancel={handleOpenChange}
          handleSave={handleOpenChange}
          user={user}
          cancelButtonLabel="Cancel"
          withinDialog
        />
      </DialogContent>
    </Dialog>
  );
};
